import { useMutation, useQueryClient } from "react-query";
import { updateCameraType1 } from "../../../../../actions/Utilities/CameraType1";
import { toast } from "components/toastNotification";
import { ICameraType1 } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { cameraType1ReFetching, editStateCameraType1 } from "../atoms/atoms";

const useEditCameraType1 = () => {
  const setActionEditState = useSetRecoilState(editStateCameraType1);
  const [isReFetching, setIsReFetching] = useRecoilState(cameraType1ReFetching);
  const { mutate } = useMutation(
    (Data: ICameraType1) => updateCameraType1(Data),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Camera Type 1 failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Camera Type 1 Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Camera Type 1 Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Camera Type 1 failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Camera Type 1 failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Camera Type 1 failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Updating Camera Type 1 failed", `${res}`, "error");
          }
        }
        // Redirect to View
        setActionEditState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Camera Type 1 failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditCameraType1;
